import { createFileRoute } from '@tanstack/react-router';
import { TechnicianPerformanceReport } from '@/components/organisms/technicians/detail/TechnicianPerformanceReport';

export const Route = createFileRoute('/_dashboard/dashboard/technicians/reports')({
  component: TechnicianReportsPage,
});

function TechnicianReportsPage() {
  return <TechnicianPerformanceReport backTo="/dashboard/technicians" />;
}
